import React from 'react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
const chips = ['6 Volumes', '60+ class plans', '5 Bonuses', 'Adults & teens', 'Mixed levels', '45 · 60 · 75 min'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Open the plan, teach the class'];
const apparatus = [{
  name: 'Silks',
  color: 'bg-coral',
  text: 'text-white'
}, {
  name: 'Hoop',
  color: 'bg-teal',
  text: 'text-white'
}, {
  name: 'Trapeze',
  color: 'bg-amber',
  text: 'text-ink'
}];
export function Hero() {
  return <section className="gym-floor relative w-full overflow-hidden text-white" data-id="element-119" data-mp="xb5rfe6eervq">
      <div className="lane-lines pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-120" data-mp="s9zwrat6gujk" />
      <div className="relative mx-auto w-full max-w-6xl px-4 pb-12 pt-6 sm:px-5 sm:pb-16 lg:pb-20 lg:pt-12" data-id="element-121" data-mp="nb6njukxbpp7">
        <div className="grid gap-7 lg:grid-cols-[1.05fr_.95fr] lg:items-center lg:gap-x-14 lg:gap-y-6" data-id="element-122" data-mp="3d33gb2q0p1mv">
          <div className="lg:col-start-1 lg:row-start-1" data-id="element-123" data-mp="380w020y5mzeq">
            <p className="inline-flex items-center gap-2 rounded-full bg-cloud px-3 py-1 text-[10px] font-semibold uppercase tracking-[1.6px] text-ink sm:text-[11px]" data-id="element-124" data-mp="3j7zhlpe3m4ju">
              <span className="h-2 w-2 rounded-full bg-coral" aria-hidden="true" data-id="element-125" data-mp="3o59chkk9b8f2" />
              Aerial Class Ready · for aerial instructors
            </p>
            <h1 className="mt-4 font-display text-[40px] font-extrabold leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-[64px] xl:text-[70px]" data-id="element-126" data-mp="3e84nze2xv0v3">
              Walk into every aerial class{' '}
              <span className="mark-hl-dark italic" data-id="element-127" data-mp="35aau09sncjb3">already planned.</span>
            </h1>
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-128" data-mp="2qlelkbmoh49y">
            <p className="max-w-xl text-[15px] leading-relaxed text-white/80 sm:text-base lg:text-lg" data-id="element-129" data-mp="2vies0nnfw91l">
              A full year of done-for-you aerial classes: 60+ ready-to-run class
              plans, skill progressions and choreography for silks, hoop and
              trapeze, with every skill at three levels for your mixed room. No
              more late nights in front of a blank plan. No more “one or two
              random tricks.”
            </p>

            <div className="mt-6 w-full max-w-md lg:mx-0" data-id="element-130" data-mp="n9i2r9bi38sj">
              <CtaButton data-id="element-131" data-mp="id050tel8app">Get Aerial Class Ready</CtaButton>
            </div>
          </div>

          <div className="lg:col-start-2 lg:row-span-4 lg:row-start-1 lg:self-center" data-id="element-132" data-mp="de6r4zve2hp0">
            <ProductVisual className="w-full max-w-[640px] lg:max-w-none" data-id="element-133" data-mp="1b15prg5n5zpj" />
          </div>

          <div className="lg:col-start-1 lg:row-start-3" data-id="element-134" data-mp="161jbd3e2udf5">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-135" data-mp="15zzubakljycb">
              <ul className="flex gap-1.5" aria-label="Covers three apparatus" data-id="element-136" data-mp="110wr7vo6g26z">
                {apparatus.map(a => <li key={a.name} className={`rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider ${a.color} ${a.text}`} data-id="element-137" data-mp="3lsyrwwxreii0">
                    {a.name}
                  </li>)}
              </ul>
              <p className="max-w-sm text-xs leading-relaxed text-white/70" data-id="element-138" data-mp="1x7hwng2h071x">
                Built for <span className="font-semibold text-white" data-id="element-139" data-mp="218tols8th4da">instructors teaching recreational adults &amp; teens</span>,
                beginner to intermediate, in the US, UK, Canada &amp; Australia
              </p>
            </div>

            <ul className="mt-5 grid gap-2 text-xs text-white/65 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-140" data-mp="2g02i4cfub9vp">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-141" data-mp="2kxknjsunf6yy">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-amber" data-id="element-142" data-mp="2ozz05v7q5ahs" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="lg:col-start-1 lg:row-start-4" data-id="element-143" data-mp="umhdsbj22joc">
            <ul className="flex flex-wrap gap-1.5 sm:gap-2" data-id="element-144" data-mp="uo0uu4cjcyr6">
              {chips.map(chip => <li key={chip} className="rounded-full border border-white/20 bg-ink-deep/50 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-white/75 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-145" data-mp="zm2lpbg7e2d7">
                  {chip}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
      <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-146" data-mp="9bigtfubbmjl" />
    </section>;
}